import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preview2020',
  templateUrl: './preview2020.component.html',
  styleUrls: ['./preview2020.component.scss']
})
export class Preview2020Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
